export default __webpack_public_path__ + "static/media/app_card_bg.a97bb629.svg";